import React, { useEffect } from 'react';
import './styles.less';
import { Grid } from '@mui/material';
import { withLayout } from 'helpers';
import { useTracker } from 'utils/tracking';
import centerImage from 'assets/ttu/not-qualified-center.avif';

function NotQualified() {
  const trackOnce = useTracker();

  useEffect(() => {
    trackOnce('Disqualified');
  }, []);

  return (
    <div className="blue_background">
      <img className="circleimage" src={centerImage} />
      <div className="notqualified_container">
        <h1 className="white label not_qualified_statement">
          Thank you for your interest in Nue Life. Unfortunately, our at-home
          treatment model doesn’t seem to be a good fit. <br />
          <br />
          If you have acute thoughts of self-harm, please call the National
          Suicide Lifeline — at 1-800-273-8255 — at 988 or seek treatment at
          your nearest hospital emergency room. The American Foundation for
          Suicide Prevention also has this informative list of additional
          resources.
        </h1>
        <a
          className="not_qualified_statement not_qualified_url"
          href="https://afsp.org/suicide-prevention-resources">
          https://afsp.org/suicide-prevention-resources
        </a>
      </div>
    </div>
  );
}

export default withLayout(NotQualified);